import PopupEditTotalPayment from './PopupEditTotalPayment';

export default PopupEditTotalPayment;
